import React from 'react';
import { useResultStore } from '@components/acca/results/result/resultStoreProvider';
import { TUTORIAL_MENU_TYPE, tutorialMenuMap } from '@domain/constant/acca/tutorial/tutorialMenuType';
import classnames from 'classnames/bind';
import styles from './srTab.module.scss';

const cx = classnames.bind(styles);

interface SrTabProps {
  menu: TUTORIAL_MENU_TYPE;
  tabIndex: number;
  setTabIndex: (tabIndex: number) => void;
}

const SrTab = ({ menu, tabIndex, setTabIndex }: SrTabProps) => {
  const { accaResultStore } = useResultStore();
  const { accSelfReportResult } = accaResultStore;

  const tabItemEl = tutorialMenuMap[menu].tabList.map((item, index) => {
    const isOn = tabIndex === index;
    const result = accSelfReportResult?.results?.find((result) => result.type === item.type);
    const isWarning = result?.unreliableYn;
    const handleClick = () => setTabIndex(index);

    return (
      <a key={index} className={cx('btnTab', { on: isOn }, { warning: isWarning })} onClick={handleClick} role="button">
        {item.tabTitle ? item.tabTitle : item.title}
      </a>
    );
  });

  return (
    <div className={cx('tabArea')}>
      <div className={cx('tabWrap')}>{tabItemEl}</div>
    </div>
  );
};

export default SrTab;
